module.exports = "/resources/assets/prod/862b704384b1ab650ae85b25f483b020.jpg";